<template>
  <div class="home">
    <div class="swiper">
      <el-carousel ref="swiper" @change="getBanner" trigger="click" :setActiveItem="bannerIndex" arrow="always">
        <el-carousel-item v-for="(item, index) in swiperList" :key="index">
          <img :src="item.image" alt="">
        </el-carousel-item>
      </el-carousel>
      <div class="swiper-bottom">
        <div class="swiper-line"></div>
        <div class="swiper-yuan">
          <div v-for="(item, index) in swiperList" :key="index"
            :class="bannerIndex != index ? 'swiper-yuan-item' : 'swiper-yuan-item_'" @click="getIndicator(index)">
            <div v-if="bannerIndex == index" class="swiper-yuan-item-cont"></div>
          </div>
        </div>
        <div class="swiper-line2"></div>
        <div class="scroll">Scroll Down</div>
        <div class="swiper-line2"></div>
        <div class="swiper-right-buttom">
          <div>{{ bannerIndex + 1 + "/" }}{{ swiperList.length }}</div>
          <div class="arrow-left"><i class="el-icon-arrow-left" color="#FFFFFF" @click="getnext('prev')"></i></div>
          <div class="arrow-right"><i class="el-icon-arrow-right" color="#FFFFFF" @click="getnext('next')"></i></div>
        </div>
        <div class="swiper-line"></div>
      </div>
    </div>
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;" v-if="solutionlist.length > 0">
      <div class="product-cont">
        <div class="product-box">
          <h1>解决方案</h1>
          <h4 v-html="navInfo"></h4>
          <div class="product-streaming">
            <div class="product-streaming-left product-image " @click="getDetails('/solutionDetails',solutionlist[0].id)">
              <img class="images" :src="solutionlist[0].index_image || ''" alt="">
              <div class="product-streaming-icon">
                <div class="product-streaming-icon-box">
                  <img src="../../static/image/1-icon.png" alt="">
                  <p>{{ solutionlist[0].title  || ''}}</p>
                </div>
              </div>
            </div>
            <div class="product-streaming-cont">
              <div class="product-streaming-cont-top product-streaming-cont-box product-image " @click="getDetails('/solutionDetails',solutionlist[1].id)">
                <img class="images" :src="solutionlist[1].index_image || ''" alt="">
                <div class="product-streaming-icon">
                  <div class="product-streaming-icon-box">
                    <img src="../../static/image/1-icon.png" alt="">
                    <p>{{ solutionlist[1].title || ''}}</p>
                  </div>
                </div>
              </div>
              <div class="product-streaming-cont-botom product-streaming-cont-box product-image" @click="getDetails('/solutionDetails',solutionlist[2].id)">
                <img class="images" :src="solutionlist[2].index_image || ''" alt="">
                <div class="product-streaming-icon">
                  <div class="product-streaming-icon-box">
                    <img src="../../static/image/1-icon.png" alt="">
                    <p>{{ solutionlist[2].title || '' }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-streaming-right product-image" @click="getDetails('/solutionDetails',solutionlist[3].id)">
              <img class="images" :src="solutionlist[3].index_image  || ''" alt="">
              <div class="product-streaming-icon">
                <div class="product-streaming-icon-box">
                  <img src="../../static/image/1-icon.png" alt="">
                  <p>{{ solutionlist[3].title  || ''}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="production animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product">
        <div class="product-cont">
          <div class="production-box">
            <div class="production-left">
              <div class="production-left-image " v-if="aboutObj.image">
                <img class="" :src="aboutObj.image  || ''" alt="">
              </div>
              <div class="production-left-content">
                <div class="production-title" v-if="aboutObj.title"> {{ aboutObj.title  || ''}}</div>
                <div class="production-content" v-if="aboutObj.description">
                  {{ aboutObj.description }}
                </div>
                <div class="production-button button-hover" @click="getTap('/aboutUs',1)">
                  <i class="el-icon-top-right" color="#FFFFFF"></i> More
                </div>
              </div>
            </div>
            <div class="production-right" v-if="aboutList.length > 0">
              <div class="aboutList" v-for="(item, index) in aboutList" :key="index"
                @mousemove="getAboutTap(item, index)">
                <div class="item-title" :style="item.ischeck ? 'color:#DB2733!important' : ''">{{ item.title }}</div>
                <div class="ischeck-box" :style="item.ischeck ? '' : 'width: 34px;'">
                  <div :class="item.ischeck ? 'yuanxin_' : 'yuanxin'">
                    <div></div>
                  </div>
                  <div class="item-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product-cont">
        <div class="product-box">
          <h1>服务中心</h1>
          <div class="service">
            <div class="service-item" v-for="(item,index) in serviceList" :key="index" @click="toService(index)">
              <div class="service-item-icon product-image">
                <img class="image images" :src="item.image  || ''" alt="">
              </div>
              <div class="service-item-title">
                {{ item.title || ''}}
              </div>
              <div class="service-item-comment">
                {{ item.desc || ''}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="about animated-fadeInUp" data-wow-delay="0.4s" style="animation-name: fadeInUp;">
      <div class="product">
        <div class="product-cont">
          <div class="about-box">
            <div class="about-left">
              <div class="about-title" v-if="info['company_desc']">
                {{ info['company_desc'].title }}
              </div>
              <div class="about-tetx" v-if="info['company_desc']">
                <div v-html="info['company_desc'].desc "></div>
              </div>
              <div class="about-button button-hover" @click="getTap('/aboutUs',0)">
                <i class="el-icon-top-right" color="#FFFFFF"></i>
                <a href="">More</a>
              </div>
              <div class="about-left-bottom">
                <div class="about-left-bottom-item" v-if="info.founded_in">
                  <animate-number from="0" :to="info.founded_in.desc" duration="2000" easing="easeOutQuad"
                    from-color="#44CC00" to-color="#ec4949"
                    style="font-size: 47px;font-family: D-DIN DIN-Bold, D-DIN DIN;font-weight: bold;color: #DB2733;display:block;"></animate-number>
                  <p class="about-left-bottom-item-text" v-if="info.founded_in">{{ info.founded_in.title  || ''}}</p>
                </div>
                <div class="about-left-bottom-item">
                  <p class="about-left-bottom-item-number" v-if="info.turnover">{{ info.turnover.desc  || ''}}<span>Billion</span></p>
                  <p class="about-left-bottom-item-text" v-if="info.turnover">{{ info.turnover.title  || ''}}</p>
                </div>
                <div class="about-left-bottom-item">
                  <p class="about-left-bottom-item-number" v-if="info.area_covered">{{ info.area_covered.desc  || ''}}<span>m²</span></p>
                  <p class="about-left-bottom-item-text" v-if="info.area_covered">{{ info.area_covered.title  || ''}}</p>
                </div>
              </div>
            </div>
            <div class="about-right product-image" v-if="info['company_desc']">
              <img class="images" :src="info['company_desc'].image || ''" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="division animated-fadeInUp">
      <div class="division-box">
        <div class="division-title">产品中心</div>
        <div class="division-list" v-if="divisionList.length > 0">
          <div class="division-list-item product-image" v-for="(item, index) in divisionList" :key="index"
            @click="getTap('/productList',index)">
            <img class="images" :src="item.image" alt="">
            <div class="division-list-item-title">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="partner animated-fadeInUp">
      <div class="partner-box">
        <div class="partner-title">合作伙伴</div>
        <div class="partner-box-content">
          <div class="partner-list" v-dragscroll>
            <div class="partner-list-item " v-for="(item, index) in partnerList" :key="index" v-if="item.logo_dark != ''"
              @mouseenter="getPartnerTap(index)" @mouseleave="getMouseleave(index)"
              :style="item.ischeck ? mousemoveStyle : ''">
              <img :src="item.ischeck ? item.logo_light : item.logo_dark" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import footerBotom from '@/components/footer.vue'
import { banner, partner, solutionList, support, divisionMenu, aboutList, company, navInfo} from '@/request/api';
export default {
  components: {
    swiper,
    swiperSlide,
    footerBotom
  },
  data() {
    return {
      bannerIndex: 0,
      swiperList: [],
      scrollTop: 0,
      serviceList: {},
      productionMenu: [],
      solutionlist: [],
      divisionList: [],
      partnerList: [],
      info: {},
      mousemoveStyle: {
        boxShadow: "0px 0px 24px 1px rgba(0,0,0,0.21)",
      },
      aboutList: [],
      aboutObj: {},
      navInfo: ''
    };
  },
  created() {
    this.getCompany()
    this.getInit()
  },
  mounted() {
  },
  methods: {
    getInit() {
      this.getbannerList()
      this.getPartner()
      this.getSolutionList()
      this.getServiceList()
      this.getMenuList()
      this.getAbouList()
      this.getNavInfo()
    },
    getNavInfo() {
      navInfo({}).then(res => {
        if (res.code == 1) {
          this.navInfo = res.data.desc
        }
      })
    },
    getCompany() {
      company({}).then(res => {
        if (res.code == 1) {
          this.info =  res.data
          localStorage.setItem('info', JSON.stringify(res.data))
        }
      })
    },
    getbannerList() {
      banner({}).then(res => {
        if (res.code == 1) {
          this.swiperList = res.data.list
        }
      })
    },
    getPartner() {
      partner({}).then(res => {
        if (res.code == 1) {
          res.data.forEach(function (item) {
            item.ischeck = false
          })
          this.partnerList = res.data
        }
      })
    },
    getSolutionList() {
      solutionList({}).then(res => {
        if (res.code == 1) {
          this.solutionlist = res.data.list
        }
      })
    },
    getMenuList() {
      divisionMenu({}).then(res => {
        if (res.code == 1) {
          this.divisionList = res.data
        }
      })
    },
    getAbouList() {
      aboutList({ channel: 24 }).then(res => {
        if (res.code == 1) {
          res.data.list.forEach(function (item) {
            item.ischeck = false
          })
          res.data.list[0].ischeck = true
          this.aboutObj = res.data.list[0]
          this.aboutList = res.data.list
        }
      })
    },
    getServiceList() {
      support({}).then(res => {
        if (res.code == 1) {
          this.serviceList = res.data;
        }
      })
    },
    getBanner(e) {
      this.bannerIndex = e
    },
    getIndicator(index) {
      // this.bannerIndex = index
      this.$refs.swiper.next()
    },
    getnext(type) {
      if (type == 'next') {
        this.$refs.swiper.next()
      } else {
        this.$refs.swiper.prev()
      }
    },
    getAboutTap(item, index) {
      this.aboutList.forEach(function (item) {
        item.ischeck = false
      })
      this.aboutList[index].ischeck = true
      this.aboutObj = item
    },
    getPartnerTap(index) {
      this.partnerList[index].ischeck = true
    },
    getMouseleave(index) {
      this.partnerList[index].ischeck = false
    },
    getTap(url, type) {
      this.$router.push({
        path: url,
        query:{
          type:type
        }
      })
    },
    getDetails(url,id){
      this.$router.push({
        path: url,
        query:{
          productId:id
        }
      })
    },
    toService(index) {
      this.$router.push({
        path: 'service',
        query:{
          to: index
        }
      })
    }
    // handleScroll() {
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   this.scrollTop = scrollTop
    // }

  }
};
</script>
<style lang="scss" scoped>
  .home {
    width: 100%;
  }

  .swiper {
    position: relative;
    height: 100vh !important;
    .swiper-bottom {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 14px;
      display: flex;
    z-index: 100;
    align-items: center;
    .swiper-line {
      display: block !important;
      width: 10%;
      opacity: 0.6;
      border: 1px solid #ffffff;
    }
  }

  .scroll {
    white-space: nowrap;
    padding: 0 17px;
    font-size: 14px;
    font-family: Arial-Narrow, Arial;
    font-weight: normal;
    color: #ffffff;
  }

  .swiper-line2 {
    width: 30%;
    // height: 1px;
    opacity: 0.6;
    border: 1px solid #ffffff;
  }

  .swiper-right-buttom {
    display: flex;
    align-items: center;
    color: #ffffff;
    font-size: 16px;

    font-weight: 400;
    color: #ffffff;
    padding: 0 17px;

    .arrow-left {
      cursor: pointer;
      margin-left: 17px;
    }

    .arrow-right {
      cursor: pointer;
      margin-left: 53px;
    }
  }

  .swiper-yuan {
    display: flex;
    align-items: center;
    margin-left: 26px;

    .swiper-yuan-item {
      cursor: pointer;
      margin-right: 26px;
      width: 7px;
      height: 7px;
      background: #ffffff;
      opacity: 0.6;
      border-radius: 100%;
    }

    .swiper-yuan-item_ {
      cursor: pointer;
      margin-right: 26px;
      width: 35px;
      height: 35px;
      opacity: 1;
      border: 1px solid #ffffff;
      border-radius: 100%;
      // position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .swiper-yuan-item-cont {
      width: 7px;
      height: 7px;
      background: #ffffff;
      opacity: 0.6;
      border-radius: 100%;
    }
  }

  >>> .el-carousel {
    height: 100% !important;
    .el-carousel__container {
      height: 100% !important;
    }
  }

  >>> .el-carousel__arrow {
    height: 100%;
    display: none;
  }

  >>> .el-carousel__indicators {
    display: none;
  }

  img {
    width: 100%;
    height: 100%;
  }
}

.product-box {
  h1 {
    text-align: center;
    font-size: 36px;
    font-family: Arial-Bold, Arial;
    font-weight: bold;
    margin: 0;
    color: #333333;
  }

  h4 {
    margin: 0;
    margin-top: 16px;
    text-align: center;
    font-size: 14px;

    color: #999999;
  }

  .product-streaming {
    margin-top: 28px;
    display: flex;
    align-content: center;
    justify-content: center;

    .product-streaming-left {
      cursor: pointer;
      width: 693px;
      max-width: 693px;
      max-height: 514px;
      height: 514px;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .product-streaming-cont {
      margin: 0 15px;

      .product-streaming-cont-box {
        width: 318px;
        height: 249px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .product-streaming-cont-botom {
        margin-top: 16px;
      }
    }

    .product-streaming-right {
      position: relative;
      width: 359px;
      height: 514px;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .product-streaming-icon {
      position: absolute;
      // top: 34%;
      // left: 40%;
      text-align: center;
      font-size: 20px;

      color: #ffffff;
      line-height: 28px;
    }
  }
}

.product-streaming-icon-box {
  img {
    width: 76px !important;
    height: 76px !important;
  }

  p {
    margin-top: 16px;
  }
}

.production {
  background-image: url("../../static/image/production.png");
  background-size: 100% 100%;

  .production-box {
    display: flex;
    justify-content: space-between;

    .production-left-image {
      width: 337px;
      height: 337px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
    }

    .production-left {
      width: 80%;
      display: flex;
      align-items: center;

      .production-left-content {
        margin-left: 65px;
        width: calc(100% - 337px - 65px);

        .production-title {
          font-size: 36px;

          color: #ffffff;
        }

        .production-content {
          margin-top: 34px;
          font-size: 16px;

          color: #ffffff;
          line-height: 26px;
        }

        .production-button {
          cursor: pointer;
          margin-top: 57px;
          width: 155px;
          height: 43px;
          text-align: center;
          line-height: 43px;
          background: #db2733;
          border-radius: 29px;
          font-size: 18px;

          color: #ffffff;
        }

        .production-button:hover {
          .el-icon-top-right {
            transition: 2s;
            transform: rotate(45deg);
          }
        }
      }
    }

    .production-right {
      .aboutList {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
      }

      .item-title {
        font-size: 16px;
        height: 75px;

        color: #ffffff;
      }

      .item-line {
        margin-left: 18px;
        height: 75px;
        border-left: 1px dashed rgba($color: #ffffff, $alpha: 0.75);
        position: relative;
      }

      .yuanxin {
        margin-left: 16px;
        width: 5px;
        height: 5px;
        background: #ffffff;
        border-radius: 100%;
      }

      .yuanxin_ {
        margin-left: 8px;
        width: 25px;
        height: 25px;
        border: 1px solid #db2733;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        div {
          width: 5px;
          height: 5px;
          background: #ffffff;
          border-radius: 100%;
        }
      }
    }
  }
}

.service {
  margin-top: 53px;
  display: flex;
  width: 100%;
  // align-items: center;
  flex-wrap: wrap;

  .service-item {
    margin-right: 30px;
    width: calc(100% / 4 - 30px);
    margin-bottom: 30px;
    text-align: center;
    cursor: pointer;

    .service-item-icon {
      display: flex;
      justify-content: center;
    }

    .service-item-title {
      margin-top: 39px;
      font-size: 20px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
    }

    .service-item-comment {
      margin-top: 28px;
      font-size: 16px;

      font-weight: 400;
      color: #999999;
      line-height: 26px;
    }
  }

  .service-item:last-child {
    margin-right: 0;
  }
}

.about {
  background-image: url("../../static/image/about-bg.png");
  background-size: 100% 100%;

  .about-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .about-left {
      max-width: 517px;

      .about-title {
        font-size: 36px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #333333;
      }

      .about-tetx {
        margin-top: 30px;
        font-size: 16px;
        // height: 458px;
        // overflow-y: scroll;
        color: #666666;
        line-height: 26px;
      }

      .about-tetx::-webkit-scrollbar {
        width: 6px;
        height: 1px;
      }

      .about-tetx::-webkit-scrollbar-thumb {
        border-radius: 12px;
        background: #db2733;
      }

      .about-tetx::-webkit-scrollbar-track {
        border-radius: 12px;
        background: #b9b9b9;
      }

      .about-button {
        margin-top: 30px;
        width: 155px;
        height: 43px;
        background: #db2733;
        border-radius: 29px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;

        color: #ffffff;

        a {
          margin-left: 15px;
        }
      }

      .about-left-bottom {
        margin-top: 30px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        // justify-content: center;

        .about-left-bottom-item {
          width: calc(100% / 3);

          .about-left-bottom-item-number {
            font-size: 47px;
            font-family: D-DIN DIN-Bold, D-DIN DIN;
            font-weight: bold;
            color: #db2733;

            span {
              font-size: 20px;
            }
          }

          .about-left-bottom-item-text {
            font-size: 14px;

            font-weight: 400;
            color: #999999;
          }
        }
      }
    }

    .about-right {
      // cursor: pointer;
      width: 700px;
      height: 458px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.division {
  padding: 60px 0;

  .division-box {
    width: 100%;
    overflow: hidden;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;

    .division-title {
      text-align: center;
      font-size: 36px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
    }

    // align-items: center;
    .division-list {
      margin-top: 37px;
      display: flex;
      align-items: center;
      justify-content: center;
      .division-list-item {
        margin-right: 25px;
        width: calc(100% / 3 - 25px);
        overflow: hidden;
        cursor: pointer; // todo

        img {
          width: 100%;
          height: 100%;
        }

        position: relative;

        .division-list-item-title {
          position: absolute;
          top: 20%;
          text-align: center;
          left: 0;
          right: 0;
          font-size: 24px;
          color: #ffffff;
        }
      }

      .division-list-item :last-child {
        margin-right: 0 !important;
      }
    }
  }

  .division-box {
    overflow: auto; //设置滚动
    scrollbar-color: transparent transparent; //兼容火狐

    &::-webkit-scrollbar {
      display: none; //隐藏滚动条
    }
  }
}

.partner {
  padding: 60px 0;

  .partner-box {
    .partner-title {
      text-align: center;
      font-size: 36px;
      font-family: Arial-Bold, Arial;
      font-weight: bold;
      color: #333333;
    }

    .partner-box-content {
      margin-top: 49px;
      // width: 100vm;
      overflow: hidden;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;

      .partner-list {
        display: flex;
        margin: 0 !important;
        margin-block-start: 0 !important;
        padding-inline-start: 0 !important;

        // flex-wrap: nowrap;
        .partner-list-item {
          // cursor: pointer; // todo
          overflow: hidden;
          display: inline-block;
          padding: 0 63px;
          width: 280px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 119px;
          background: #ffffff;
          border: 1px solid #e4e4e4;

          img {
            // width: 130.98px;
            width: 148.98px;
            height: auto;
            // height: 43.49px;
          }
        }
      }
    }

    .partner-box-content {
      overflow: auto; //设置滚动
      scrollbar-color: transparent transparent; //兼容火狐

      &::-webkit-scrollbar {
        display: none; //隐藏滚动条
      }
    }
  }
}
// @media screen and (max-width: 1550px) {
//   .swiper {
//     height: 558px !important;
//   }
// }
// @media screen and (max-width: 1080px) {
//   .swiper {
//     height: 558px !important;
//   }
// }
@media screen and (max-width: 767px) {
  .swiper {
    overflow: hidden;
    height: 300px !important;
  }

  .service-item {
    margin-right: 0 !important;
    width: calc(100% / 2) !important;
  }

  .about-left {
    width: 100%;
  }

  .about-right {
    display: none;
  }

  .product-streaming {
    display: block !important;

    .product-streaming-left {
      width: 100% !important;
      height: auto !important;
    }

    .product-streaming-right {
      width: 100% !important;
      height: auto !important;
    }

    .product-streaming-cont {
      margin: 15px 0 !important;

      .product-streaming-cont-box {
        width: 100% !important;
        height: auto !important;
      }
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  .production-box {
    display: block !important;

    .production-left {
      display: block !important;
    }
  }

  .about-left-bottom-item {
    width: calc(100% / 2) !important;
  }

  .production-left {
    width: 100% !important;

    .production-left-image {
      display: none;
    }
  }

  .production-left-content {
    width: 100% !important;
    margin: 0 !important;
    margin-top: 20px;
  }

  .production-right {
    margin-top: 30px;
    display: flex !important;

    .aboutList {
      .item-title {
        display: none;
        height: auto !important;
      }

      .ischeck-box {
        display: flex;
        align-items: center;
      }

      // display: block !important;
      .item-line {
        margin-left: 0 !important;
        width: 30px !important;
        height: 1px !important;
        border-top: 1px dashed rgba($color: #ffffff, $alpha: 0.75);
      }

      .yuanxin {
        margin-left: 0 !important;
        width: 5px;
        height: 5px;
        background: #ffffff;
        border-radius: 100%;
      }

      .yuanxin_ {
        margin-left: 8px;
        width: 25px;
        height: 25px;
        border: 1px solid #db2733;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        div {
          width: 5px;
          height: 5px;
          background: #ffffff;
          border-radius: 100%;
        }
      }
    }
  }

  .division {
    padding: 30px 0 !important;

    .division-list {
      display: block !important;

      .division-list-item {
        width: 100% !important;
        margin-bottom: 10px;
      }
    }
  }

  .partner {
    padding: 30px 0 !important;

    .partner-list-item {
      padding: 0 120px !important;

      img {
        object-fit: cover;
      }
    }
  }
}
.swiper-bottom {
  .swiper-line {
    display: none !important;
  }
  .swiper-right-buttom {
    padding: 0 !important;
  }
  .swiper-yuan-item_{
    width: 26px !important;
    height: 26px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue